import type { InternalShareResourceType } from "@/components/chat/message/internal-share-card";

export const INTERNAL_SHARE_DRAG_TYPE = "internal-share-resource";

export type InternalShareDragData = {
  dragType: typeof INTERNAL_SHARE_DRAG_TYPE;
  resourceType: InternalShareResourceType;
  resourceId: number | string;
  title: string;
};

export function isInternalShareDragData(value: unknown): value is InternalShareDragData {
  if (!value || typeof value !== "object") {
    return false;
  }

  const data = value as Partial<InternalShareDragData>;
  return (
    data.dragType === INTERNAL_SHARE_DRAG_TYPE &&
    (data.resourceType === "conversation" ||
      data.resourceType === "email" ||
      data.resourceType === "social_comment" ||
      data.resourceType === "form_submission" ||
      data.resourceType === "ticket") &&
    Number.isFinite(Number(data.resourceId))
  );
}
